import { render, staticRenderFns } from "./ExitCafeItem.vue?vue&type=template&id=0065eb07&"
import script from "./ExitCafeItem.vue?vue&type=script&lang=js&"
export * from "./ExitCafeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports